import { SuccessNoContentResponse } from '../global-types';

export const successNoContentResponse: SuccessNoContentResponse<null> = {
  meta: {
    code: 204,
    version: '2.2.0',
  },
  data: null,
};
